import auth from './auth';
import result from './result';

export default {
  auth: auth(),
  result: result(),
};
